import React, { ReactNode } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import Sidebar from "src/components/layouts/sidebar/Sidebar";
import Breadcrumb from "src/components/layouts/Common/Breadcrumb";
import ThirdStepNursery from "src/components/panel/applications_nursery/application_third_step/ThirdStep";
import * as AppConfig from "../../../../helpers/AppConfig";

const MakeApplicationsThirdStepNurseryView: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t("applications_list_view")}</title>
      </Helmet>
      <Sidebar>
        <Breadcrumb title={t("applications_title")} />
        <ThirdStepNursery />
      </Sidebar>
    </>
  );
};

export default MakeApplicationsThirdStepNurseryView;
